import React from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import logo from '../../Assets/Img/logo.png';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="Pool Route Monitor - Home" />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;